import { VERTICAL_KEYS } from '../vertical.js';
import { imobiliarioGeralLandingContent } from './imobiliario-geral.js';
import { mcmvLandingContent } from './mcmv-imobiliario.js';
import { protecaoVeicularLandingContent } from './protecao-veicular.js';
import type { VerticalLandingContent } from './types.js';

// =============================================================================
// Registry of landing-page content per vertical. The public-facing FE
// resolves the right content by the broker's verticalKey (returned in the
// GET /public/broker/:subdomain response).
//
// Default is MCMV · legacy brokers without a verticalKey continue to render
// the MCMV landing exactly as before.
// =============================================================================

const REGISTRY = new Map<string, VerticalLandingContent>([
  [VERTICAL_KEYS.MCMV_IMOBILIARIO, mcmvLandingContent],
  [VERTICAL_KEYS.PROTECAO_VEICULAR, protecaoVeicularLandingContent],
  [VERTICAL_KEYS.IMOBILIARIO_GERAL, imobiliarioGeralLandingContent],
]);

export const FALLBACK_LANDING_CONTENT: VerticalLandingContent = mcmvLandingContent;

export function getLandingContent(
  verticalKey: string | undefined,
): VerticalLandingContent {
  if (!verticalKey) return FALLBACK_LANDING_CONTENT;
  return REGISTRY.get(verticalKey) ?? FALLBACK_LANDING_CONTENT;
}

export { imobiliarioGeralLandingContent, mcmvLandingContent, protecaoVeicularLandingContent };
export type { VerticalLandingContent, LandingFAQItem, LandingHowStep } from './types.js';
